import { render, staticRenderFns } from "./StepViewCreateOreder.vue?vue&type=template&id=7b3feaa1"
import script from "./StepViewCreateOreder.vue?vue&type=script&lang=js"
export * from "./StepViewCreateOreder.vue?vue&type=script&lang=js"
import style0 from "./StepViewCreateOreder.vue?vue&type=style&index=0&id=7b3feaa1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports